////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { cloneDeep, reject } from 'lodash'
import styled from 'styled-components'
///////COMPONENTS///////
import ListSearchable from '../../../components/ListSearchable'
import { PageGridTitle, PageGridBorder, InputLogin, SearchInputWrapper, SearchInputButton, SearchReset } from '../../../theme/GlobalCss'

//////STYLED//////
const RolesListUserManagerWrapper = styled.div`
	position: relative;
`
const ListActions = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
`
const SearchUserWrapper = styled.div`
	position: relative;
	display: flex;
	margin: 10px;
	& > * > input {
		font-size: ${(props) => props.theme.font.fs};
	}
`
//////STYLED//////

const RolesListUserManager = (props) => {
	const [searchValue, setSearchValue] = useState('')
	const [searched, setSearched] = useState('')

	const { translations, rolesManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			rolesManager: state.rolesManager,
		}),
		shallowEqual
	)

	const [inputData, setInputData] = useState(rolesManager.roleDetail.users)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleInputData = () => {
		let newinputData = cloneDeep(rolesManager.roleDetail.users)

		if (searchValue.length > 0) {
			newinputData = reject(newinputData, (o) => {
				let str = cloneDeep(o.fullName)
				str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
				let transformed_search = cloneDeep(searchValue)
				transformed_search = transformed_search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
				return str.toUpperCase().includes(transformed_search.toUpperCase()) ? false : true
			})
		}
		setInputData(newinputData)
	}

	const handleSearchValue = (e) => {
		setSearchValue(e.target.value)
	}

	const handleSearch = (e) => {
		setSearched(searchValue)
	}

	const handleSearchEnter = (e) => {
		if (e.keyCode === 13 || searchValue === '') setSearched(searchValue)
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const columns = [
		// We set what data value is used to
		// For setting value of input
		{ isCheckboxValue: true, dataHook: 'id', headerName: 'id' },
		// For labelling the item
		{ isLabel: true, dataHook: 'fullName', headerName: 'fullName', alreadyTranslated: true },
	]

	const config = {
		name: `${translations['page__roleManagement__roleSheet_userRole_definition']} : ${rolesManager.roleDetail.role.label}`,
		labelSelected: translations['page__roleManagement__roleSheet_selectedUser'],
		filters: {
			searchValue: searched,
		},
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		// Whenever we change filters, we redraw the list
		handleInputData()
	}, [searched])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<RolesListUserManagerWrapper>
			<PageGridTitle>{config.name}</PageGridTitle>
			<PageGridBorder>
				<ListActions>
					{rolesManager.roleDetail.filters && (
						<SearchUserWrapper>
							<SearchInputWrapper>
								<InputLogin
									value={searchValue}
									onChange={handleSearchValue}
									onKeyDown={handleSearchEnter}
									placeholder={translations['page__roleManagement__roleSheet_user_search']}
								/>
								<SearchInputButton onClick={handleSearch} />
							</SearchInputWrapper>
							{searchValue.length > 0 && (
								<SearchReset
									onClick={() => {
										setSearchValue('')
										setSearched('')
									}}
								/>
							)}
						</SearchUserWrapper>
					)}
				</ListActions>
				{rolesManager.roleDetail.users && (
					<ListSearchable
						inputData={inputData}
						summaryList={props.recapList}
						inputColumns={columns}
						translationMode={true}
						hookList={props.setUserList}
						inputConfig={config}
						sizeHeightActions={440}
						readOnly={props.readOnly}
						forceReduxData={true}
					/>
				)}
			</PageGridBorder>
		</RolesListUserManagerWrapper>
	)
}

RolesListUserManager.propTypes = {}

RolesListUserManager.defaultPropTypes = {}

export default RolesListUserManager
